import React from 'react'
import styled from 'styled-components'

const Styles = styled.div`
  border-radius: 20px;
  border: solid 2px #ffe8d0;
  background-color: #ffffff;
  padding: 22px;
  margin-bottom: 20px;
`

const Card = ({ children = '' }) => {
  return <Styles>{children}</Styles>
}

export default Card
